var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 3.5H2.91667H12.25",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 3.49984V11.6665C11.0833 11.9759 10.9604 12.2727 10.7416 12.4915C10.5228 12.7103 10.226 12.8332 9.91663 12.8332H4.08329C3.77387 12.8332 3.47713 12.7103 3.25833 12.4915C3.03954 12.2727 2.91663 11.9759 2.91663 11.6665V3.49984M4.66663 3.49984V2.33317C4.66663 2.02375 4.78954 1.72701 5.00834 1.50821C5.22713 1.28942 5.52387 1.1665 5.83329 1.1665H8.16663C8.47605 1.1665 8.77279 1.28942 8.99158 1.50821C9.21038 1.72701 9.33329 2.02375 9.33329 2.33317V3.49984",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83337 6.4165V9.9165",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16663 6.4165V9.9165",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashOutline);
export default __webpack_public_path__ + "static/media/trash-outline.a0583896629b489cfef76b716fcf7a2c.svg";
export { ForwardRef as ReactComponent };